<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      系统设置
      <!-- 支付日志/异常订单记录 -->
      <small>/&nbsp;支付日志列表</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">支付日志列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">订单号</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="订单编号"
                          v-model="orderNo"
                        />
                      </div>
                      <label class="col-md-1 col-form-label">支付流水号</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="支付流水号"
                          v-model="payVoucher"
                        />
                      </div>
                      <label class="col-md-1 col-form-label">收款人</label>
                      <div class="col-md-3">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="收款人"
                          v-model="trueName"
                        />
                      </div>
                      <div class="col-md-2"></div>
                      <!-- 订单状态   -->
                      <label class="col-md-1 col-form-label LineSpacing">订单状态</label>
                      <div class="col-md-2 LineSpacing">
                        <!-- :rules="rules" ref="ruleForm" -->
                        <el-select
                          v-model="orderStatus"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in orderStatusList "
                            :key="item.code "
                            :label="item.name"
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </div>

                      <!-- 服务商ID -->
                      <label class="col-md-1 col-form-label LineSpacing">服务商名称：</label>
                      <div class="col-md-2 LineSpacing">
                        <v-selectpage
                          :data="allrecomIdList"
                          key-field="recomId"
                          show-field="recomName"
                          placeholder="服务商名称"
                          v-model="allrecomId"
                          @values="selectOrder"
                          title
                        ></v-selectpage>
                      </div>
                      <!--  -->
                      <label class="col-md-1 col-form-label LineSpacing">门店ID：</label>
                      <div class="col-md-2 LineSpacing">
                        <v-selectpage
                          :data="allshopIdList"
                          key-field="shopId"
                          show-field="shopName"
                          placeholder="门店名称"
                          v-model="allshopId"
                          title
                        ></v-selectpage>
                      </div>
                      <div class="col-md-1 LineSpacing">
                        <a class="btn btn-primary ButtonColor m-r-5" @click="SearchClick()">查询</a>
                      </div>
                    </div>
                    <!-- <div style="margin-bottom:15px;text-align:right;">
                      <a class="btn btn-primary ButtonColor m-r-5" @click="ExportClick()">导出</a>
                      <a
                        class="btn btn-warning ButtonColor"
                        style="margin-right:16px;"
                        @click="CancelOrder()"
                      >取消订单</a>
                    </div>-->
                  </fieldset>
                </form>
                <el-table
                  :data="UserManagementList"
                  border
                  @selection-change="handleSelectionChange"
                >
                  <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column
                    prop="recom"
                    label="渠道号"
                    align="center"
                    width="150"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="orderNo"
                    label="订单号"
                    align="center"
                    width="150"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="recomName"
                    label="服务商名称"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="shopName"
                    label="门店名称"
                    align="center"
                    width="200"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="payVoucher"
                    label="支付流水号"
                    align="center"
                    width="250"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="trueName"
                    label="订购人"
                    align="center"
                    width="100"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="idCard"
                    label="身份证号"
                    align="center"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="payTime"
                    label="下单时间"
                    align="center"
                    width="180"
                    show-overflow-tooltip
                  ></el-table-column>
                  <!-- <el-table-column fixed="right" label="支付申报" align="center" width="100">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="DeclareClick(scope.row)"
                        :disabled="scope.row.declaredisabled"
                      >支付申报</button>
                    </template>
                  </el-table-column>-->
                  <el-table-column fixed="right" label="操作" width="180" align="center">
                    <template slot-scope="scope">
                      <a
                        class="btn btn-primary btn-sm ButtonColor"
                        data-toggle="modal"
                        @click="DetailClick(scope.row)"
                      >详情</a>
                      <!--  :disabled="scope.row.canceldisabled" -->
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        @click="CancelClick(scope.row)"
                      >删除订单</button>
                    </template>
                  </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <!-- <el-dialog title :visible.sync="outerVisible" width="500px">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定取消吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <div class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure">确定</div>
          </div>
          <div class="swal-button-container">
            <div class="swal-button swal-button--cancel btn btn-default" @click="MakeCancel">取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 3" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定支付申报吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>-->
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "OrderList",
  data() {
    return {
      // 订单状态
      orderStatus: 1,
      orderStatusList: [
        {
          code: 0,
          name: "已处理"
        },
        {
          code: 1,
          name: "未处理"
        }
      ],
      // 服务商id    服务商名称
      allrecomId: "",
      allrecomIdList: [],

      // 门店id
      allshopId: "",
      allshopIdList: [],
      //  收款人
      trueName: "",
      //  显示 数量
      pageSize: 10,
      // 总数量
      totalCount: 0,
      // 页码大小
      pageindex: 1,
      // 订单号
      orderNo: "",
      //  支付流水号
      payVoucher: "",
      // bagNo: "",
      // startTime: "",
      // endTime: "",
      // shopName: "",
      
      outerVisible: false,
      inputdisabled: true,
      DialogTitle: "编辑",
      EditDialog: 1,
      outerWidth: "500px",
      orderFrom: "",
      CurrentSelection: [],
      options: [],
      CloseShow: false,
      CloseShows: false,
      BrandOptions: [],
      brand: "",
      ruleForm: {},
      rules: {},
      RecomList: [],
      fuzzyRecom: "",
      TimeValue: "",
      disabled: false,
      // 表格数据    ----查询的接口
      UserManagementList: [],
      DeclareList: [],
      multipleSelection: [],
      cancelShow: false,
      cancelone: false,
      //  是否显示  门店  ID
      isO2O: false
    };
  },
  watch: {
    pageNo: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pageNo) {
          this.pageNo = this.$route.params.pageNo;
        }
      },
      immediate: true
    },
    pagesize: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pagesize) {
          this.pageSize = this.$route.params.pagesize;
        }
      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set(val) {
        if (val) {
          this.pageindex = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    },
    pagesize: {
      set(val) {
        if (val) {
          this.pageSize = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    }
  },
  mounted: function() {
    // if (this.$route.params && this.$route.params.searchContent) {
    //   this.orderNo = this.$route.params.searchContent.orderNo;
    //   // this.fuzzyRecom = this.$route.params.searchContent.fuzzyRecom;

    //   if (
    //     this.$route.params.searchContent.TimeValue !== null &&
    //     this.$route.params.searchContent.TimeValue !== ""
    //   ) {
    //     this.startTime = this.FormatAllDate(
    //       this.$route.params.searchContent.TimeValue[0]
    //     );
    //     this.endTime = this.FormatAllDate(
    //       this.$route.params.searchContent.TimeValue[1]
    //     );
    //   } else {
    //     this.startTime = "";
    //     this.endTime = "";
    //   }

    //   this.TimeValue = this.$route.params.searchContent.TimeValue;
    //   this.orderStatus = this.$route.params.searchContent.orderStatus;
    //   this.orderFrom = this.$route.params.searchContent.orderFrom;
    // }
    //  初始化  加载数据 级联查询
    this.initdata();
    // 加载  订单 列表
    this.inintList();
    // 订单状态数据
    // this.OrderStatusData();
  },
  methods: {
    CancelOrder() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          title: "失败",
          message: "请选择一条数据",
          type: "error"
        });
      } else {
        this.multipleSelection.forEach(element => {
          if (
            element.orderStatus !== 1 &&
            element.orderStatus !== 2 &&
            element.orderStatus !== 3 &&
            element.orderStatus !== 4
          ) {
            this.cancelShow = true;
          }
        });

        if (this.cancelShow) {
          this.$notify({
            title: "失败",
            message: "请选择正确的数据",
            type: "error"
          });
        } else {
          this.outerVisible = true;
          this.EditDialog = 2;
        }
      }
    },
    // 删除
    CancelClick(row) {
      let that = this;
      const options = {
        url: "/distribution/PayExceptionOrderController/delExceptionOrder",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({ id: row.id })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          // 订单状态
          this.CurrentSelection = row;
          this.outerVisible = true;
          this.cancelone = true;
          this.EditDialog = 2;
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
          //重新初始化数据
          this.inintList();
        }
      });
      // console.log(row.id);
    },
    //  以 服务商ID     门店  ID二级联动
    selectOrder(val) {
      // console.log(10000)

      if (val.length > 0) {
        // console.log(val);
        let that = this;
        const options = {
          url: "/distribution/B2cRecomInfoController/queryRecomAndshop",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            // recomId      必填项
            recomId: val[0].recomId
            //
            // status:"1"
          })
        };
        axios(options).then(response => {
          if (response.data.code == 200) {
            if (response.data.data.length > 0) {
              that.allshopIdList = response.data.data;
            }
          }
        });
      }
    },

    MakeSure() {
      let that = this;
      let orderNos = [];
      if (this.cancelone) {
        orderNos.push({
          orderId: this.CurrentSelection.orderId,
          orderNo: this.CurrentSelection.orderNo,
          orderStatus: this.CurrentSelection.orderStatus
        });
      } else {
        this.multipleSelection.forEach(val => {
          orderNos.push({
            orderId: val.orderId,
            orderNo: val.orderNo,
            orderStatus: val.orderStatus
          });
        });
      }

      that.disabled = true;
      const options = {
        url: "distribution/B2cOrderInfoController/deleteOrders",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          orderNos: orderNos,
          orderStatus: that.CurrentSelection.orderStatus
        }
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          that.cancelone = false;
          that.cancelShow = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.outerVisible = false;
          that.cancelShow = false;
          that.disabled = false;
          that.cancelone = false;
          http.handleHttpError(error, that);
        });
    },
    MakeCancel() {
      this.outerVisible = false;
      this.cancelone = false;
      this.cancelShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // ExportClick() {
    //   let that = this;
    //   const options = {
    //     url: "/distribution/B2cOrderInfoController/orderListExport",
    //     method: "get",
    //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //     params: {
    //       orderNo: that.orderNo,
    //       fuzzyRecom: that.fuzzyRecom,
    //       orderFrom: that.orderFrom,
    //       orderStatus: that.orderStatus,
    //       startTime: that.startTime,
    //       endTime: that.endTime
    //     }
    //   };
    //   axios(options)
    //     .then(function(response) {
    //       if (response.data.code !== undefined) {
    //         http.handleEorrorCode(response, that);
    //       } else {
    //         that.ExportClickSecond();
    //       }
    //     })
    //     .catch(error => {
    //       http.handleHttpError(error, that);
    //     });
    // },
    // ExportClickSecond() {
    //   let that = this;
    //   const options = {
    //     url: "/distribution/B2cOrderInfoController/orderListExport",
    //     method: "get",
    //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //     params: {
    //       orderNo: that.orderNo,
    //       // fuzzyRecom: that.fuzzyRecom,
    //       // orderFrom: that.orderFrom,
    //       // orderStatus: that.orderStatus,
    //       // startTime: that.startTime,
    //       // endTime: that.endTime
    //     },
    //     responseType: "blob"
    //   };
    //   axios(options)
    //     .then(function(response) {
    //       var filename = "订单列表" + new Date().getTime();
    //       let url = window.URL.createObjectURL(response.data);
    //       let link = document.createElement("a");
    //       link.style.display = "none";
    //       link.href = url;
    //       link.setAttribute("download", filename + ".xlsx");
    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch(error => {
    //       http.handleHttpError(error, that);
    //     });
    // },
    DeclareClick(item) {
      this.outerVisible = true;
      this.EditDialog = 3;
      this.CurrentSelection = item;
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
    },
    MakeSureEdit(formName) {
      let that = this;
      that.disabled = true;
      const options = {
        url: "distribution/B2cDeclareCustomsController/declareType",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          payType: that.CurrentSelection.payType,
          orderNo: that.CurrentSelection.orderNo,
          recom: that.CurrentSelection.recom
        }
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 详情的处理函数
    DetailClick(row) {
      let searchContent = {};
      // 订单号
      searchContent.orderNo = this.orderNo;
      //  支付流水号
      searchContent.payVoucher = this.payVoucher;
      // 收款人
      searchContent.trueName = this.trueName;
      // 订单状态
      // searchContent.orderStatus = this.orderStatus;
      this.$router.push({
        path: "/OrderDetailsummary"
        // query: {
        //   //  服务商 ID
        //   recomId: row.recomId,
        //   // 服务商名称
        //   recomName: row.recomName,
        //   // 渠道号
        //   recom: row.recom,
        //   // 门店ID
        //   shopId: row.shopId,
        //   // 门店名称
        //   shopName: row.shopName,
        //   // 订单号
        //   orderNo: row.orderNo,
        //   // 支付流水号
        //   payVoucher: row.payVoucher,
        //   // 状态
        //   status: row.status,
        //   // 收款人
        //   trueName: row.trueName,
        //   // 支付时间
        //   payTime: row.payTime,
        //   // 异常秒返订单ID
        //   id: row.id,
        //   // 订单金额
        //   amount: 358,
        //   //身份证号
        //   idCard: row.idCard,
        //   // 银行名称
        //   bankName: row.bankName,
        //   // 银行卡号
        //   bankCard: row.bankCard,
        //   // 秒返入参
        //   inputData: row.inputData,
        //   // 秒返出参
        //   responseData: row.responseData,
        //   // 失败原因
        //   failure: row.failure,
        //   // 系统异常信息
        //   exceptionMsg: row.exceptionMsg
        // }
      });
      //本地存储
      localStorage.setItem(
        "paylist",
        JSON.stringify({
          // 当前行 的 详情
          row: row,
          pageNo: this.pageindex,
          pageSize: this.pageSize,
          searchContent: searchContent
        })
      );
    },

    // 分页的 处理函数
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    // 查询    的处理函数
    SearchClick() {
      this.pageindex = 1;
      let that = this;
      const options = {
        // 查询  接口
        url: "/distribution/PayExceptionOrderController/queryExceptionOrder",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          // 订单号
          orderNo: that.orderNo,
          //  服务商ID
          recomId: that.allrecomId,
          //   门店ID
          shopId: that.allshopId,
          //   订单号
          orderNo: that.orderNo,
          //  支付流水号    ----不能查询到
          payVoucher: that.payVoucher,
          //   收款人
          trueName: that.trueName,
          // 状态：1-未处理；0-已处理----必填项

          status: that.orderStatus,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            // that.cancelShow = false;
            for (var i in response.data.data.records) {
              // 强行添加   ordernumber 属性  ----序号
              response.data.data.records[i].ordernumber =
                Number((that.current - 1) * that.pageSize) + Number(i) + 1;
            }
            // 表格数据
            that.UserManagementList = response.data.data.records;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 日期的处理函数
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
    // 订单状态数据
    // OrderStatusData() {
    //   const options = {
    //     url: "distribution/b2c-distribution-status-controller/query-all",
    //     method: "post",
    //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //     data: Qs.stringify({})
    //   };
    //   axios(options)
    //     .then(response => {
    //       if (response.data.code == 200) {
    //         this.orderStatusList = response.data.data;
    //       } else {
    //         http.handleEorrorCode(response, this);
    //       }
    //     })
    //     .catch(error => {
    //       http.handleEorrorCode(response, this);
    //     });
    // },
    // 初始化数据  --- 级联 接口
    initdata() {
      let that = this;
      const options = {
        url: "/distribution/B2cRecomInfoController/queryRecomAndshop",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          //  服务商ID
          // recomId: that.recomId
        })
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            that.cancelShow = false;
            for (var i in response.data.data) {
              var obj = {};
              obj.recomName = response.data.data[i].recomName;
              obj.recomId = response.data.data[i].recomId;
              that.allrecomIdList.push(obj);
            }
            // 表格数据
            // that.UserManagementList = response.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 初始化  秒返异常  单 查询接口
    inintList() {
      let that = this;
      var options = {
        url: "/distribution/PayExceptionOrderController/queryExceptionOrder",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          //  服务商ID   ----必填项
          recomId: that.allrecomId,
          //   // 门店ID
          // shopId: 1,
          // 输入框
          //  订单号
          orderNo: that.orderNo,
          //
          // 支付流水号
          payVoucher: that.payVoucher,
          // ,
          //  收款人
          trueName: that.trueName,
          //  that.trueName,
          // 状态：1-未处理；0-已处理
          status: that.orderStatus
        })
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            for (var i = 0; i < response.data.data.records.length; i++) {
              //  goodsid  为  自定义  属性 --- 【序号】
              response.data.data.records[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            }
            // 数据总数量
            that.totalCount = response.data.data.totalCount;
            // 总页码
            that.pageindex = response.data.data.current;
            //每页显示数量
            that.pageSize = response.data.data.size;
            // 当前页码
            that.current = response.data.data.current;
            // 表格数据
            if (response.data.data.records.length > 0) {
              that.UserManagementList = response.data.data.records;
            }
          } else {
            that.$notify({
              title: "失败",
              message: response.data.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderManage/OrderListsummary.vue